import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useLanguage } from "../components/LanguajeContext";
import { translations } from "../utils/reservation.translate";
import { FaSpinner, FaMoneyBillWave, FaTimesCircle } from "react-icons/fa";

const URL = process.env.REACT_APP_SERVER_URL;

const PaymentPageClient = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language];

  const [valid, setValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reservation, setReservation] = useState(null);

  const token = searchParams.get("token");

  useEffect(() => {
    const validate = async () => {
      try {
        const res = await fetch(`${URL}/api/booking/validate-token?token=${token}`);
        const data = await res.json();
        if (!res.ok) throw new Error("Token inválido");
        setReservation(data.message);
        setValid(true);
      } catch (err) {
        console.error(err);
        setValid(false);
      } finally {
        setLoading(false);
      }
    };
    if (token) validate();
  }, [token]);

  const handlePay = async () => {
  
    navigate("/pago/exitoso");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        <FaSpinner className="animate-spin text-4xl" />
      </div>
    );
  }

  if (!valid) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="bg-white shadow-lg rounded-lg p-8 text-center">
            <FaTimesCircle className="text-red-500 text-6xl mx-auto mb-4" />
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              {t.verification.invalidToken}
            </h2>
            <button
              onClick={() => navigate("/")}
              className="mt-4 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
            >
              {t.reservation.backToHome}
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-xl w-full">
          <div className="flex items-center mb-6">
            <FaMoneyBillWave className="text-green-600 text-2xl mr-2" />
            <h1 className="text-2xl font-bold text-gray-900">
              {t.reservation.paymentMethod}
            </h1>
          </div>

          <div className="border rounded-lg p-6 mb-6">
            <h2 className="font-bold mb-3">{t.reservation.bookingSummary}</h2>
            <p className="text-gray-700">
              <span className="font-semibold">{t.reservation.service}:</span>{" "}
              {reservation?.service?.name}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">{t.reservation.date}:</span>{" "}
              {reservation?.date_service}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">{t.reservation.participants}:</span>{" "}
              {reservation?.participants}
            </p>
          </div>

          <button
            onClick={handlePay}
            className="w-full py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            {t.reservation.payNow}
          </button>
        </div>
      </div>
    </>
  );
};

export default PaymentPageClient;
